import { ConsultantNode } from './consultant-node';
import { ColorConfig } from './../../../color-config';
import { EmployerIds } from '../../../../util/app-constants';
import { Colors } from '../../../../util/colors';

export class NonTechyConsultantNode extends ConsultantNode {
    protected initdraw() {
        this.svgSymbol = this.organigram.appendSymbol('nontechSymbol');
        this.initdrawexperience();
        this.redraw();
        this.svgSymbol.click(this.handleClick);

        this.svgSymbol.mouseover(() => this.handleHover());
        this.svgSymbol.mouseout(() => this.handleOut());
        this.disable();
    }
}
